import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';

const SiteSettings = () => {
  const [siteSettings, setSiteSettings] = useState({
    allowRegistration: true
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // Site ayarlarını getir
  const fetchSiteSettings = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      
      const { data } = await axios.get('/api/site-settings', config);
      
      if (data.success) {
        setSiteSettings(data.siteSettings);
      }
    } catch (error) {
      setError('Site ayarları yüklenirken bir hata oluştu');
      toast.error('Site ayarları yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSiteSettings();
  }, []);

  // Form değişikliklerini takip et
  const handleChange = (e) => {
    const { name, checked } = e.target;
    setSiteSettings({
      ...siteSettings,
      [name]: checked
    });
  };

  // Site ayarlarını kaydet
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      
      const { data } = await axios.put('/api/site-settings', siteSettings, config);
      
      if (data.success) {
        toast.success('Site ayarları başarıyla kaydedildi');
        setSiteSettings(data.siteSettings);
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Site ayarları kaydedilirken bir hata oluştu';
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </Spinner>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <Card>
          <Card.Header>
            <h5 className="mb-0">Site Ayarları</h5>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Label className="mb-0">Kayıt İşlemlerine İzin Ver</Form.Label>
                  <Form.Check
                    type="switch"
                    id="allowRegistration"
                    name="allowRegistration"
                    checked={siteSettings.allowRegistration}
                    onChange={handleChange}
                    className="fs-4"
                  />
                </div>
                <Form.Text className="text-muted">
                  Bu ayar kapalıyken, yeni kullanıcılar siteye kayıt olamaz.
                </Form.Text>
              </Form.Group>
              
              <div className="d-flex justify-content-end">
                <Button 
                  variant="primary" 
                  type="submit"
                  disabled={saving}
                >
                  {saving ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default SiteSettings;
